function backOut(t) {
  var s = 1.70158
  return --t * t * ((s + 1) * t + s) + 1
}

module.exports = backOut


//////////////////
// WEBPACK FOOTER
// ./~/eases/back-out.js
// module id = 122
// module chunks = 35783957827783 255223432971881